(ns app.front.ui.saved-searches-dropdown
  "Saved searches button + dropdown. Re-frame-free and tr-free: labels come in as plain
  strings; row preview texts are built at the caller layer (::saved-search-rows)."
  (:require [app.front.ui.dropdown :as ui-dd]
            [app.front.util :as futil]
            [clojure.string :as str]
            [core.util.util :as util]))

;; Filled dark count pill of the mockup.
(def ^:private count-badge-span
  :span.inline-block.rounded.bg-ui-night-sky-100.px-2.py-0.5.font-semibold.leading-4.text-white.text-xs)

(defn- toggle-content [{:keys [label count]}]
  [:span.flex.items-center.gap-2
   [:span.uppercase.font-semibold.text-sm
    label]
   (when (pos? count)
     [count-badge-span count])])

(defn- row
  "One entry: an apply button (name + preview) with a sibling underlined Remove button at
  the bottom-right. Native buttons keep keyboard activation."
  [{:keys [search on-apply on-remove remove-label]}]
  [:div.px-3.py-2.border-b.border-solid.border-ui-light-gray.hover:bg-ui-violet-10
   {:data-cy "saved-search-option"}
   [:button.w-full.text-left.bg-transparent.border-0.p-0.cursor-pointer
    {:type     "button"
     :on-click #(on-apply (:filter search))}
    [:span.block.font-semibold.text-sm.text-ui-night-sky-100
     (:name search)]
    (when-not (str/blank? (:preview-text search))
      [:span.block.mt-1.text-xs.leading-4.text-ui-muted
       (:preview-text search)])]
   [:div.flex.justify-end.mt-1
    [:button.uppercase.text-xs.underline.bg-transparent.border-0.cursor-pointer.text-ui-night-sky-100
     {:type       "button"
      :aria-label (str remove-label ": " (:name search))
      :on-click   (fn [e]
                    ;; Keep the dropdown open and don't apply: the options container closes on any bubbled click.
                    (.stopPropagation e)
                    (on-remove (:id search)))
      :data-cy    "saved-search-remove"}
     remove-label]]])

(defn saved-searches-dropdown
  "Props:
    :label        - toggle button label
    :searches     - rows ({:id :filter :name :preview-text}), cf. ::saved-search-rows
    :on-apply     - called with the row's :filter entity on row click
    :on-remove    - called with the row's :id on Remove click (dropdown stays open)
    :remove-label - Remove link text
    :empty-text   - text shown when :searches is empty
    :data-cy      - data-cy hook for the toggle button"
  [{:keys [label searches on-apply on-remove remove-label empty-text data-cy]}]
  [ui-dd/dropdown
   {:class         "flex-none"
    :toggle-props  {:class   "px-2 py-1 rounded border border-solid border-ui-night-sky hover:bg-ui-violet-10 gap-2"
                    :data-cy data-cy}
    :options-props {:class "w-80 max-h-96 bg-white rounded-md shadow-lg border border-solid border-ui-light-gray"}}
   [toggle-content {:label label :count (count searches)}]
   (if (seq searches)
     (futil/for-frag [search searches]
       ^{:key (:id search)}
       [row (util/mmap {:search       search
                        :on-apply     on-apply
                        :on-remove    on-remove
                        :remove-label remove-label})])
     [:div.px-3.py-2.text-sm.text-ui-muted
      {:data-cy "saved-searches-empty"}
      empty-text])])
